import React, { useState, useEffect, useRef } from 'react';
import { Text, View, Image, TextInput, ScrollView, Pressable, Keyboard } from 'react-native';

import { store } from '../../store/store';
import { launchCameraAsync, MediaTypeOptions, launchImageLibraryAsync } from 'expo-image-picker';

import { pwaGUID } from '../CommonService';
import { getImagePath, isObjectNotEmpty } from '../../utils/services/CommonUtils';
import { getCommonDateTime, getMessageDateTime } from '../../utils/services/DateTimeUtils';
import { updateMessagesDownloadImageListToRedux } from '../../utils/services/redux/commonRedux';
import { doMultipart as doOMSMultipart, doPost as doOMSAPI } from '../../utils/services/api/OMSAPI';
import { MoengageEvents, trackMoengageEvents } from '../../utils/services/webapp-services/MoengageUtils';
import { getFileDownloadUrlList, getOrderStatus, isOrderActive, refreshOrder } from '../../utils/services/oms/OMSUtils';
import { DeeplinkDataSubscription, WebSocketMessageSubscription } from '../../utils/services/subject-behaviour/CommonRxjsService';

import { IconView } from '../../utils/widgets/CommonWidget/Icons';
import { CommonRightChevronIcon } from '../../utils/widgets/Common-Widget';
import { CommonPharmacyHeader } from '../../utils/widgets/CommonWidget/CommonHeader';

import { msgType } from '../../utils/constants/ConstantsMapping';
import { ActiveOrderStatus } from '../../utils/constants/oms/OrderStatus';
import { NavigateFrom, ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { Ampersand, AppVersionCode, EntityTypePharmacy, EntityTypeUser, IndiaRupee } from '../../utils/constants/AppConstants';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import disableScroll from "disable-scroll"

import ToastModal from '../../utils/modals/ToastModal';
import SupportViewModal from '../../utils/modals/SupportViewModal';
import CommonBottomSheet from '../../utils/modals/CommonBottomSheet';
import PhotoCaptureModel from '../../utils/modals/PhotoCaptureModal';

import ModalContent from '../../utils/constants/ModalContentConstant';

import * as AlertService from "../../utils/services/AlertLoaderService";

const pako = require('pako');

const MessageView = (props) => {

    const [messageList, updateMessageList] = useState([])

    const [orderDetails, updareOrderDetails] = useState({})
    const [pharmacyData, updatePharmacyData] = useState({})
    const [message, updateMesaage] = useState('')

    const [showLastUploadedImage, setShowLastUploadedImage] = useState(false);
    const [LastUploadedImageUrl, setLastUploadedImageUrl] = useState('');
    const [downloadedImagesList, updateDownloadedImagesList] = useState({})

    const [toastData, setToastData] = useState({ showToast: false, text: '' })

    const [photoCaptureModal, setPhotoCaptureModal] = useState(false)

    let scrollViewRef: any = useRef();

    function getMessagePayload(message) {
        // don't the reason for two times parsing.
        return JSON.parse(JSON.parse(JSON.stringify(message['payload'])))
    }

    function getMessageList({ showLoader = true }) {
        if (showLoader)
            AlertService.loaderModal.setLoader(true)
        const params = {
            orderId: props.route.params?.orderData['oid'], pwa: true,
            pid: props.route.params?.orderData?.pharmacyData['id']
        }
        doOMSAPI('order/message/list', params).then(
            (response: any) => {
                var charData = atob(response['messagesV2']).split('').map(function (x) { return x.charCodeAt(0); });
                var binData = new Uint8Array(charData);
                var data = pako.inflate(binData);
                var messageJson = String.fromCharCode.apply(null, new Uint16Array(data));
                if (ActiveOrderStatus.indexOf(getOrderStatus(response['order'])) != -1) {
                    response['order']['isActiveOrder'] = true
                }
                updareOrderDetails({
                    ...response['order'],
                    isActive: isOrderActive(response['order'])
                })
                updatePharmacyData(response['order']['pharmacies'][0])
                let messagesList: any = JSON.parse(messageJson);

                let findLastImgUrlIndex = messagesList.map((item) => item['msgType']).lastIndexOf(9);

                if (showLastUploadedImage && LastUploadedImageUrl && findLastImgUrlIndex && messagesList?.length > findLastImgUrlIndex) {
                    messagesList[findLastImgUrlIndex]['imgDownloaded'] = LastUploadedImageUrl
                }
                updateMessageList(messagesList)
                AlertService.loaderModal.setLoader(false)
                setTimeout(() => {
                    scrollViewRef?.current?.scrollIntoView({ behavior: "smooth" })
                }, 1000);
            }, (error) => {
                AlertService.loaderModal.setLoader(false);
                setToastData({ showToast: true, text: error['msg'] })
            }
        )
    }

    function PharmacySentPriceView(message) {
        const message_payload = JSON.parse(message['payload'])
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>
            <View style={[AppStyles.mediumShadow,
            AppStyles.mb8,
            AppStyles.bgWhite,
            { borderRadius: 12, width: (AppTheme.appWidth - 32) * 0.61 }]}>

                <View style={{ padding: 16 }}>

                    <View style={[AppStyles.flexRow, {}]}>
                        <IconView icon={'notification_blue.svg'} size={16} />
                        <Text style={[TextStyle.text12b, { color: AppTheme.color.blue.cta, marginLeft: 4 }]}>Pricing sent by the store</Text></View>

                    <Text style={[TextStyle.text16b, { color: AppTheme.color.blue.cta, marginTop: 16 }]}>
                        {IndiaRupee}{message_payload['payableAmount'] + message_payload['deliveryChargeAmount'] ?? 0} {
                            message_payload['payableAmount'] + message_payload['deliveryChargeAmount'] < message_payload['totalAmount'] ?
                                <Text style={{ color: AppTheme.color.grey.lightText }}>
                                    {IndiaRupee}<Text style={{ textDecorationStyle: "solid", textDecorationLine: "line-through", textDecorationColor: AppTheme.color.grey.lightText }}>
                                        {message_payload['totalAmount']}</Text></Text> : null} </Text>

                    {message_payload['deliveryChargeAmount'] != 0 ?
                        <Text style={[TextStyle.text10xb, { color: AppTheme.color.blue.cta, marginTop: 10 }]}>
                            Delivery charge included: {IndiaRupee}{message_payload['deliveryChargeAmount']}</Text> : null}

                </View>

                <View style={{
                    backgroundColor: AppTheme.color.blue.oms_detail_card_upper_bg,
                    paddingHorizontal: 16, paddingVertical: 8, marginTop: 16
                }}>

                    <Text style={[TextStyle.text12,
                    { color: AppTheme.color.blue.cta }]}>
                        Expected Delivery</Text>

                    <Text style={[TextStyle.text12,
                    { color: AppTheme.color.blue.cta }]}>
                        {getCommonDateTime(pharmacyData?.['offer']['estDelTime'])}</Text>

                </View>

                <Pressable style={[AppStyles.flexRowSpaceBetween, {
                    backgroundColor: AppTheme.color.blue.oms_detail_card_lower_bg,
                    paddingVertical: 10, paddingHorizontal: 16, borderBottomRightRadius: 12
                }]}
                    onPress={() => {
                        localStorage.setItem('orderDetails', JSON.stringify(orderDetails));
                        [2, 3, 6].includes(orderDetails['status']) || !message['isActionable'] ?
                            props.navigation.navigate(ScreenRoute.view_order_summary,
                                { orderData: orderDetails, isActionable: message['isActionable'] }) :
                            props.navigation.navigate(ScreenRoute.view_order_details,
                                { orderData: orderDetails, isActionable: message['isActionable'] })
                    }}>

                    <Text style={[TextStyle.text14xb, { color: AppTheme.color.primary, marginRight: 6 }]}>
                        {message['isActionable'] ? 'Continue' : 'View Details'}</Text>

                    {CommonRightChevronIcon('blue')}

                </Pressable>


            </View>

            {getMessageDateTime(message['ts'])}</View>

    }

    function getPaymentAcceptedLabel() {
        if (orderDetails['ropsData']) {
            return `Order confirmed ${Ampersand} paid ${IndiaRupee}${orderDetails['ropsData']['amountPaid']} successfully`
        } else return ` Order confirmed, please pay ${IndiaRupee}${orderDetails['pharmacies'][0]?.offer?.payableAmount + orderDetails['pharmacies'][0]?.offer?.deliveryChargeAmount} on delivery`
    }

    function OrderPayVia() {
        return <View style={[AppStyles.mb24, { backgroundColor: AppTheme.color.grey.bg, paddingVertical: 6, borderRadius: 20, alignContent: "center", alignItems: "center" }]}>
            <Text style={[TextStyle.text12xb]}> {getPaymentAcceptedLabel()}</Text></View>
    }

    function OrderOutForDeliveryView(message) {
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>
            <View style={[AppStyles.mediumShadow, AppStyles.mb8,
            AppStyles.bgWhite, {
                width: (AppTheme.appWidth - 32) * 0.61,
                borderTopLeftRadius: 12, borderTopRightRadius: 12, borderBottomRightRadius: 12
            }]}><View style={[AppStyles.flexRow, { padding: 16 }]}>
                    <IconView icon={'notification_green.svg'} size={16} />
                    <Text style={[TextStyle.text12b, {
                        color: AppTheme.color.green.primary, marginLeft: 4
                    }]}>Out for delivery</Text></View>

                <View style={{
                    paddingHorizontal: 16, paddingVertical: 8,
                    backgroundColor: AppTheme.color.green.lightPrimary
                }}><Text style={[TextStyle.text12,
                { color: AppTheme.color.green.primary }]}>
                        Confirm  your order delivery.</Text></View>

                <Pressable style={[AppStyles.flexRowSpaceBetween, {
                    backgroundColor: AppTheme.color.green.primary, borderBottomRightRadius: 12,
                    paddingVertical: 10, paddingHorizontal: 16
                }]} onPress={() => { orderDetails['isActiveOrder'] ? showMarkdeliverModal() : null }}>
                    <Text style={[TextStyle.text14xb, { color: 'white' }]}>Confirm Now</Text>
                    <IconView icon={'right_circle_white.svg'} size={12} />
                </Pressable>

            </View>

            {getMessageDateTime(message['ts'])}</View>
    }

    function OrderDispatchedView(message) {
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>
            <View style={[AppStyles.mediumShadow, AppStyles.flexRow, AppStyles.mb8, { padding: 16, borderTopLeftRadius: 12, borderTopRightRadius: 12, borderBottomRightRadius: 12 }]}>

                <IconView icon={'notification_green'} size={16} />
                <Text style={[TextStyle.text12b, { color: AppTheme.color.green.primary, marginLeft: 4 }]}>Order Delivered</Text></View>

            {getMessageDateTime(message['ts'])}</View>
    }

    function SehatSikkeEarnedView(message) {
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>
            <View style={[AppStyles.mediumShadow, AppStyles.flexRowSpaceBetween,
            AppStyles.mb8, {
                padding: 16, borderRadius: 12, borderWidth: 1,
                borderColor: '#DD6700', backgroundColor: '#FCF2E0', width: AppTheme.appWidth * 0.65
            }]}><View>
                    <View style={AppStyles.flexRow}>
                        <IconView icon={'ss_coin.svg'} size={24} />
                        <Text style={[TextStyle.text24xb, { paddingLeft: 8 }]}>{'50'}</Text>
                    </View>
                    <Text style={[TextStyle.text12, { color: 'rgba(0, 0, 0, 0.87)', paddingTop: 4 }]}>
                        Sehat Sikke Earned</Text>
                </View>
                <IconView icon={'right_chev_orange.svg'} size={16} />
            </View>
        </View>
    }

    function userMessageView(textMessage, message) {
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>
            <View style={[AppStyles.mb8, AppStyles.flexRow, { justifyContent: 'flex-end' }]}>
                <Text style={[AppStyles.mediumShadow, AppStyles.bgWhite, TextStyle.text12b, {
                    padding: 16, maxWidth: AppTheme.appWidth * 0.7,
                    borderTopLeftRadius: 12, borderTopRightRadius: 12, borderBottomLeftRadius: 12
                }]}>
                    {textMessage}</Text></View>
            <View style={[AppStyles.flexRow, { justifyContent: 'flex-end' }]}>
                {getMessageDateTime(message['ts'])}</View>
        </View>
    }

    function pharmacyMessageView(textMessage, message) {
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>
            <View style={[AppStyles.mb8, AppStyles.flexRow, { justifyContent: 'flex-start' }]}>
                <Text style={[AppStyles.mediumShadow, AppStyles.bgWhite, TextStyle.text12b, {
                    padding: 16, maxWidth: AppTheme.appWidth * 0.7,
                    borderTopLeftRadius: 12, borderTopRightRadius: 12, borderBottomRightRadius: 12
                }]}>
                    {textMessage}</Text></View>
            <View style={[AppStyles.flexRow, { justifyContent: 'flex-start' }]}>
                {getMessageDateTime(message['ts'])}</View>
        </View>
    }

    function TextMessageView(message) {
        const payload = JSON.parse(message['payload'])
        if (message['srcType'] == EntityTypeUser)
            return userMessageView(payload['message'], message)
        else if (message['srcType'] == EntityTypePharmacy)
            return pharmacyMessageView(payload['message'], message)
        else return null
    }

    function checkThumbnailUrl(messagePayload) {
        if (!messagePayload) {
            return null;
        } else {
            let payloadData = JSON.parse(JSON.parse(JSON.stringify(messagePayload)))
            if (payloadData['thumbnail']) {
                return payloadData['thumbnail']
            } else {
                return null
            }
        }
    }

    function getMessageThumnailUrl(message) {
        let payloadData = getMessagePayload(message)
        if (payloadData['thumbnail'])
            return payloadData['thumbnail']
        else if (Object.keys(downloadedImagesList).includes(String(message['mid'])))
            return downloadedImagesList[String(message['mid'])]
        else return getImagePath('/images/icons/download.svg')
    }

    async function getMessageImageUrl(message) {
        if (Object.keys(downloadedImagesList).includes(String(message['mid']))) {
            previewMessageImage(downloadedImagesList[String(message['mid'])])
        } else {
            let payloadData = getMessagePayload(message)
            let messageImageList = await getFileDownloadUrlList([payloadData['downloadToken']])
            downloadedImagesList[message['mid']] = messageImageList[0]['redirectUrl']
            updateDownloadedImagesList(downloadedImagesList);
            updateMessagesDownloadImageListToRedux(downloadedImagesList);
            previewMessageImage(messageImageList[0]['redirectUrl'])
        }
    }


    function ImageMessageView(message) {
        return <View style={[AppStyles.mb24]} key={'view_' + message['mid']}>

            {message['srcType'] == EntityTypeUser ?
                <View style={[AppStyles.mb8, AppStyles.flexRow, { justifyContent: 'flex-end' }]}>
                    <Pressable onPress={() => getMessageImageUrl(message)}
                        onLongPress={() => { console.log('### long press') }}
                        style={[AppStyles.borderView, AppStyles.bgWhite, AppStyles.p8]}>
                        <Image style={{ width: 60, height: 60, backgroundColor: '#FFFFFF', }}
                            source={{ uri: getMessageThumnailUrl(message) }} />
                    </Pressable>
                </View> : message['srcType'] == EntityTypePharmacy ?
                    <View style={[AppStyles.mb8, AppStyles.flexRow, { justifyContent: 'flex-start' }]}>
                        <Pressable onPress={() => getMessageImageUrl(message)}
                            onLongPress={() => { console.log('### long press') }}
                            style={[AppStyles.borderView, AppStyles.bgWhite, AppStyles.p8]}>
                            <Image style={{ width: 60, height: 60, backgroundColor: '#FFFFFF', }}
                                source={{ uri: getMessageThumnailUrl(message) }} />
                        </Pressable>
                    </View> : null
            }

            {message['srcType'] == EntityTypePharmacy ?
                <View style={[AppStyles.flexRow, { justifyContent: 'flex-start' }]}>
                    {getMessageDateTime(message['ts'])}</View> :
                message['srcType'] == EntityTypeUser ?
                    <View style={[AppStyles.flexRow, { justifyContent: 'flex-end' }]}>
                        {getMessageDateTime(message['ts'])}</View> : null}
        </View>
    }

    const [supportModal, setSupportModal] = useState(false);
    const [markOrderDeliverModal, setMarkDeliverModal] = useState(false);

    function markDeliver() {
        const params = {
            orderId: orderDetails['oid'], pid: pharmacyData['id'],
            orderReceived: true, appVersionCode: AppVersionCode, appGUID: pwaGUID()
        }
        AlertService.loaderModal.setLoader(true)
        doOMSAPI('order/close', params).then(
            (response: any) => {
                if (response.status != 401) {
                    const reduxState = store.getState()
                    trackMoengageEvents(MoengageEvents.oms_order_delivered)
                    if (reduxState['orderList'].length > 1)
                        trackMoengageEvents(MoengageEvents.subsequent_order_success)
                    // update response.order in order list
                    // instrad of calling incremental api. 
                    refreshOrder()
                    if (props.navigation.canGoBack())
                        props.navigation.popToTop();
                    props.navigation.replace(ScreenRoute.orders);
                    AlertService.loaderModal.setLoader(false);
                }
            }, (err: any) => { console.log("API is failed with error " + err) }
        )
    }

    const previewMessageImage = (imageUrl) => {
        var imageUrlList = [{ imageUrl: imageUrl }]
        props.navigation.navigate(ScreenRoute.images_preview,
            { imageList: imageUrlList })
    }

    const showMarkdeliverModal = () => {
        // disableScroll.on()
        setMarkDeliverModal(true)
    }

    const closeMarkdeliverModal = () => {
        disableScroll.off()
        setMarkDeliverModal(false)
    }

    const showSupportModal = () => {
        // disableScroll.on()
        setSupportModal(true)
    }

    const closeSuportModal = () => {
        disableScroll.off()
        setSupportModal(false)
    }


    const showPhotoCaptureModal = () => {
        // disableScroll.on()
        setPhotoCaptureModal(true)
    }

    const closePhotoCaptureModal = () => {
        disableScroll.off()
        setPhotoCaptureModal(false)
    }

    useEffect(() => {
        const reduxState = store.getState()
        if (reduxState.isUserLogin) getMessageList({});
        else {
            DeeplinkDataSubscription.setDeeplinkData({
                deeplinkData: props.route.params
            })
            global.navigateFrom = NavigateFrom.deeplink_message_view;
            props.navigation.replace(ScreenRoute.login);
        }

        WebSocketMessageSubscription.getWebSocketMessage().subscribe((data) => {
            if (data && data instanceof Object) {
                if (orderDetails['oid'] === data?.['orderId'])
                    getMessageList({ showLoader: false });
            }
        })

        let downloadedChatImagesList = reduxState.downloadedChatImagesList;
        if (isObjectNotEmpty(downloadedChatImagesList)) {
            updateDownloadedImagesList(downloadedChatImagesList);
        }

    }, [])

    function messageView(message) {
        switch (message['msgType']) {
            case msgType.ORDER_CREATED: return null;
            case msgType.ORDER_ACCEPTED: return PharmacySentPriceView(message);
            case msgType.ORDER_DECLINED: return null;
            case msgType.OFFER_ACCEPTED: return OrderPayVia();
            case msgType.OFFER_REJECTED: return null;
            case msgType.LOCATION: return null;
            case msgType.PAYMENT_METHOD: return null;
            case msgType.TEXT: return TextMessageView(message);
            case msgType.ATTACHMENT: return ImageMessageView(message);
            case msgType.PAYMENT: return null;
            case msgType.CONFIRMED_WITH_OTHER_STORE: return null;
            case msgType.ORDER_CANCELLED: return null;
            case msgType.ORDER_DELIVERED: return OrderDispatchedView(message);
            case msgType.UNFULFILLED: return OrderDispatchedView(message);
            case msgType.PAYMENT_CONFIRMATION: return null;
            case msgType.ORDER_DISPATCHED: return OrderOutForDeliveryView(message);
            case msgType.EARNED_SEHAT_SIKKE: return SehatSikkeEarnedView(message);
            default: return null;
        }
    }

    async function sendImage(type) {
        const params = {
            oid: orderDetails['oid'],
            orderId: orderDetails['oid'],
            pid: pharmacyData['id'],
        }
        if (type === 'camera') {
            let result: any = await launchCameraAsync({
                mediaTypes: MediaTypeOptions.Images,
                allowsEditing: true,
                aspect: [4, 3],
                quality: 0,
            });
            if (!result.cancelled) {
                sendImage(params, result.uri);

            }
        }

        else {
            let result: any = await launchImageLibraryAsync({
                mediaTypes: MediaTypeOptions.Images,
                allowsEditing: true,
                aspect: [4, 3],
                quality: 0,
            });
            if (!result.cancelled) {
                sendImage(params, result.uri)
            }
        }

        async function sendImage(params, imageData) {
            setLastUploadedImageUrl(imageData);
            setShowLastUploadedImage(true);
            AlertService.loaderModal.setLoader(true)

            const form: FormData = new FormData();
            let blob = await (await fetch(imageData)).blob();
            form.append('file', blob)
            form.append('orderData', JSON.stringify(params));

            doOMSMultipart('order/message/send_image', form).then(
                (response: any) => {
                    updateMesaage('')
                    var charData = atob(response['messagesV2']).split('').map(function (x) { return x.charCodeAt(0); });
                    var binData = new Uint8Array(charData);
                    var data = pako.inflate(binData);
                    var messageJson = String.fromCharCode.apply(null, new Uint16Array(data));
                    response['order']['isActiveOrder'] = orderDetails['isActiveOrder']
                    updareOrderDetails({
                        ...response['order'],
                        isActive: isOrderActive(response['order'])
                    })
                    updatePharmacyData(response['order']['pharmacies'][0])
                    let messagesList: any = JSON.parse(messageJson);
                    let findLastImgUrlIndex = messagesList.map((item) => item['msgType']).lastIndexOf(9);
                    if (findLastImgUrlIndex) {
                        updateDownloadedImagesList({ ...downloadedImagesList, [messagesList[findLastImgUrlIndex]['mid']]: imageData })
                        updateMessagesDownloadImageListToRedux({ ...downloadedImagesList, [messagesList[findLastImgUrlIndex]['mid']]: imageData })
                    }

                    updateMessageList(messagesList)
                    AlertService.loaderModal.setLoader(false)
                    setTimeout(() => {
                        scrollViewRef.current.scrollIntoView({ behavior: "smooth" })
                    }, 1000);
                }
            )
        }
    }

    function sendMessage() {
        AlertService.loaderModal.setLoader(true)
        const messageListLastIndex = messageList.length - 1
        const lastMid = messageList[messageListLastIndex]['mid']
        const payload = {
            message: message,
            estDelTime: orderDetails['estDelTime']
        }

        const params = {
            msgData: {
                msgType: msgType.TEXT,
                sourceType: EntityTypeUser,
                targetType: EntityTypePharmacy,
                payload: JSON.stringify(payload),
                targetId: pharmacyData['id'],
            },
            orderId: orderDetails['oid'],
            pid: pharmacyData['id'],
            lastMid: lastMid
        }

        doOMSAPI('order/message/send', params).then(
            (response: any) => {
                trackMoengageEvents(MoengageEvents.chat_msg_sent)
                updateMesaage('')
                var charData = atob(response['messagesV2']).split('').map(function (x) { return x.charCodeAt(0); });
                var binData = new Uint8Array(charData);
                var data = pako.inflate(binData);
                var messageJson = String.fromCharCode.apply(null, new Uint16Array(data));
                response['order']['isActiveOrder'] = orderDetails['isActiveOrder']
                updareOrderDetails({
                    ...response['order'],
                    isActive: isOrderActive(response['order'])
                })
                updatePharmacyData(response['order']['pharmacies'][0])
                var lastMessage: any = []
                lastMessage = JSON.parse(messageJson)
                const updeatedMessageList = messageList.concat(lastMessage)
                updateMessageList(updeatedMessageList)
                AlertService.loaderModal.setLoader(false)
                setTimeout(() => {
                    scrollViewRef.current.scrollIntoView({ behavior: "smooth" })
                }, 1000);
            }, () => {
                AlertService.loaderModal.setLoader(false)
            }
        )
    }

    return (
        <View style={{ minHeight: AppTheme.appHeight, backgroundColor: AppTheme.color.white }}>

            {!!orderDetails && !!pharmacyData && <View>

                <CommonPharmacyHeader
                    navigation={props.navigation}
                    title={pharmacyData['name']}
                    pharmacyData={pharmacyData} />

                <View style={{
                    width: AppTheme.appWidth,
                    display: 'flex',
                    justifyContent: 'center',
                    left: (AppTheme.appWidth / 2) - 25
                }}>
                </View>

                <View style={{ height: AppTheme.headerHeight }} />

                <ScrollView style={[AppStyles.px16, AppStyles.pt16, { marginBottom: 64 }]}>
                    {messageList && messageList.length ? messageList.map((message, index) => (
                        <View key={message['mid']}>
                            {message['hidden'] ? null : messageView(message)}</View>
                    )) : null}
                    <View ref={scrollViewRef} ></View>
                </ScrollView>

                {
                    orderDetails['status'] && orderDetails['status'] !== 3 ?
                        <View style={[AppStyles.bottomFix,
                        AppStyles.flexRowSpaceBetween, AppStyles.topBorderView, {
                            borderColor: 'black', padding: 16,
                            borderBottomWidth: 0, borderRightWidth: 0, borderLeftWidth: 0
                        }]}>

                            <View style={[AppStyles.flexRow]}>

                                <Pressable onPress={() => {
                                    Keyboard.dismiss();
                                    showPhotoCaptureModal();
                                }} onLongPress={() => { console.log('### long press') }}>
                                    <Image source={{ uri: getImagePath('/images/icons/attach.svg'), width: 9.2, height: 18 }}
                                        style={[{ marginRight: 16 }]} /></Pressable>

                                <TextInput style={[TextStyle.text14, { width: AppTheme.appWidth - 100 }]}
                                    underlineColorAndroid="transparent"
                                    value={message} autoFocus={true} placeholder={'Send a message...'}
                                    onChangeText={text => { updateMesaage(text) }} />

                            </View>

                            <Pressable onPress={() => {
                                Keyboard.dismiss();
                                setTimeout(() => sendMessage(), 100)
                            }} disabled={!message} onLongPress={() => { console.log('### long press') }}>
                                <IconView icon={'send.svg'} width={18} height={17} /></Pressable>
                        </View> : null
                }
            </View>}

            <SupportViewModal showPopup={supportModal}
                closeModal={closeSuportModal} />

            <CommonBottomSheet key={'mark deliver'}
                hasSecondaryCTA={true}
                showModal={markOrderDeliverModal}
                modalData={ModalContent.MarkOrderDelivered}
                closeModal={closeMarkdeliverModal}
                primaryAction={markDeliver}
                secondaryAction={showSupportModal} />

            <PhotoCaptureModel
                showPhotoCaptureModal={photoCaptureModal}
                closeModal={closePhotoCaptureModal}
                capturePhotoAction={(type) => sendImage(type)} />

            <ToastModal showToast={toastData['showToast']}
                setToast={(toastData: any) => { setToastData(toastData) }}
                text={toastData['text']} />

        </View>)
}

export default MessageView;
